<template>
  <div class="comp-verification-logs">

    <div class="response-items scrollable -y scrollbar-hidden">
    <!-- <div class="response-items"> -->
      <div class="verification-info">
        <div class="verification-info-item highlight">
          Verification Status
        </div>
        <div class="verification-info-item">
          <span
          v-bind:class="{
            black: !verificationResult,
            blue: verificationResult === 'cancel',
            red: verificationResult === 'dispatch'
          }"
          class="result-badge">{{verificationResult ? getEnduserFriendlyResultString(verificationResult) : 'No response'}}</span>
          <span
          v-bind:class="{
            blue: !isCompleted && !verificationResult,
            blink: !isCompleted && !verificationResult
          }"
          class="result-badge">{{isCompleted || verificationResult ? 'Completed' : 'Waiting...' + countDown}}</span>
        </div>
        <div class="verification-info-item">Requested at {{verificationLocaleString}}{{friendlyVerificationTimeString ? ' (' + friendlyVerificationTimeString + ')' : ''}}</div>
      </div>
      <div v-if="responseList.length < 1"
      class="no-response-text">Nobody has responded</div>
      <div
      v-else
      v-for="(responseData, index) in responseList"
      v-bind:key="index"
      class="response-item">
        <div class="response-item-title">
          <div class="info-name">
            <span 
            v-if="responseData.slotNumber !== null"
            class="slot-number">{{responseData.slotNumber}}</span>
            <span>{{responseData.name ? responseData.name : 'No name'}}</span>
          </div>
          <div class="info-time">{{responseData.localeTimeString}}</div>
        </div>
        <div
        v-bind:class="{
          'not-crime': responseData.response === 'cancel',
          'crime': responseData.response === 'dispatch'
        }"
        class="response-item-content">{{getEnduserFriendlyResultString(responseData.response)}}</div>
      </div>
      <div class="response-item-footer"></div>
    </div>

  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-verification-logs',
  components: {
    CompIcon
  },
  computed: {
    verificationInfo: function () {
      return this.$store.getters.verificationInfo
    },
    verificationRequesterDealer: function () {
      return this.$store.getters.verificationRequesterDealer
    },
    verificationRequesteeMe: function () {
      return this.$store.getters.verificationRequesteeMe
    },
    verificationRequesteeSite: function () {
      return this.$store.getters.verificationRequesteeSite
    },
    verificationRequesteeSiteContacts: function () {
      return this.$store.getters.verificationRequesteeSiteContacts
    },
    verificationSitePrivacyDeviceList: function () {
      return this.$store.getters.verificationSitePrivacyDeviceList
    },
    statusGetVerification: function () {
      return this.$store.getters.statusGetVerification
    },
    statusGetVerificationSitePrivacyStatus: function () {
      return this.$store.getters.statusGetVerificationSitePrivacyStatus
    },
    // new feature
    verificationDuration: function () {
      return this.$store.getters.siteVerificationDuration
    }
  },
  data: function () {
    return {
      isVisible: false,
      verificationTimeLimit: 60 * 2, // 60 * 2 // 2 minutes
      isCompleted: true,
      verificationResult: null,
      verificationLocaleString: null,
      friendlyVerificationTimeString: null,
      countDown: 120,
      responseList: []
    }
  },
  watch: {
    verificationInfo: function (now) {
      // console.warn(now)
    },
    verificationRequesterDealer: function (now) {
      // console.warn(now)
    },
    verificationRequesteeMe: function (now) {
      // console.warn(now)
    },
    verificationRequesteeSite: function (now) {
      // console.warn(now)
    },
    verificationRequesteeSiteContacts: function (now) {
      // console.warn(now)
    },
    verificationSitePrivacyDeviceList: function (now) {
      // console.warn(now)
    },
    statusGetVerification: function (now) {
      // console.warn(now)
      this.onChangeStatusGetVerification(now)
    },
    statusGetVerificationSitePrivacyStatus: function (now) {
      // console.warn(now)
    }
  },
  created: function () {
    this.isVisible = true
    this.getVerification()
    this.getVerificationSitePrivacyStatus()
    this.$on('addTimeCount', function (timeCount) {
      this.countDown += timeCount
    })
    this.getSiteVerificationDuration()
      .then(res => {
        this.countDown = res.verification_duration
      })
      .catch(err => {
        console.log(err)
      })
  },
  mounted () {
    // this.getSiteVerificationDuration()
    //   .then(res => {
    //     console.log(res)
    //     this.countDown = res.veirification_duration
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })
  },
  beforeDestroy: function () {
    this.isVisible = false
  },
  methods: {
    getVerification: function () {
      this.$store.dispatch('getVerification')
    },
    getVerificationSitePrivacyStatus: function () {
      this.$store.dispatch('getVerificationSitePrivacyStatus')
    },
    setVerificationResult: function (result) {
      this.$store.commit('SET_VERIFICATION_RESULT', {result: result})
    },
    setVerificationIsCompleted: function (isCompleted) {
      this.$store.commit('SET_VERIFICATION_ISCOMPLETED', {isCompleted: isCompleted})
    },
    getSiteVerificationDuration: function () {
      return this.$store.dispatch('getSiteVerificationDuration')
    },
    onChangeStatusGetVerification: function (status) {
      let refreshDataInterval = 1000 * 1
      if (status === 'successful') {
        this.updateVerificationRelatedInfo()
        // update again only when the last result is successful
        if (this.isVisible && !this.isCompleted) {
          setTimeout(() => {
            this.getVerification()
          }, refreshDataInterval)
        }
      }
    },
    getEnduserFriendlyResultString: function (result) {
      if (result === 'cancel') {
        return 'disregard'
      } else if (result === 'dispatch') {
        return 'dispatch'
      } else {
        return result
      }
    },
    updateVerificationRelatedInfo: function () {
      this.responseList = []
      if (this.verificationInfo) {
        if (this.verificationRequesteeSite) {
          let timezoneOffset = this.$tool.getUtcOffset(this.verificationRequesteeSite.timezone)
          let verificationLocalTimestamp = this.$tool.getLocalTimestamp(+this.verificationInfo.statusInfo.createdDate.getTime(), timezoneOffset)
          this.verificationLocaleString = new Date(verificationLocalTimestamp).toLocaleString()
        }
        this.friendlyVerificationTimeString = this.$tool.getTimeDiffFromNow(+this.verificationInfo.statusInfo.createdDate.getTime()).textDetail + ' ago'
        // update isCompleted
        let secondDiffFromNow = this.$tool.getTimeDiffFromNow(+this.verificationInfo.statusInfo.createdDate.getTime()).diffInSec
        // this.verificationTimeLimit = 60 * 60 * 24 * 10 // just for testing.
        // console.log('siteVerificationDuration', this.verificationDuration)
        // console.log('secondDiffFromNow',secondDiffFromNow)
        // console.log(this.verificationDuration - secondDiffFromNow)
        if (secondDiffFromNow > this.verificationDuration) {
          this.isCompleted = true
          this.countDown = 0
        } else {
          this.isCompleted = false
          this.countDown = this.verificationDuration - secondDiffFromNow
        }
        this.$store.commit('REMAIN_VERIFICATION_TIME_UPDATE', {remainTime: this.countDown})
        this.setVerificationIsCompleted(this.isCompleted)
        // update responseList
        Object.keys(this.verificationInfo.responseList).map(contactId => {
          Object.keys(this.verificationInfo.responseList[contactId]).map(timestamp => {
            if (this.verificationInfo.responseList[contactId][timestamp].response) {
              let responseInfo = {
                contactId: contactId,
                timestamp: timestamp,
                name: null,
                slotNumber: null,
                localeTimeString: this.getLocaleTimeString(timestamp),
                friendlyTimeString: this.getFriendlyTimeString(timestamp),
                response: this.verificationInfo.responseList[contactId][timestamp].response,
                geoIpMetaData: this.verificationInfo.responseList[contactId][timestamp].geoIpMetaData
              }
              if (this.verificationRequesteeSiteContacts[contactId]) {
                responseInfo.name = this.verificationRequesteeSiteContacts[contactId].name
                responseInfo.slotNumber = this.verificationRequesteeSiteContacts[contactId].slotNumber
              }
              this.responseList.push(responseInfo)
            }
          })
        })
        // sort in time order
        this.responseList.sort(function (a, b) {
          if (a.timestamp < b.timestamp) return -1
          if (a.timestamp > b.timestamp) return 1
          return 0
        })
        // catch the first response from the verification contact
        this.verificationResult = null
        for (let i = 0; i < this.responseList.length; i++) {
          let validResponseList = ['dispatch', 'cancel']
          validResponseList.map(validResponse => {
            if (this.responseList[i].response === validResponse) {
              this.verificationResult = this.responseList[i].response
            }
          })
          if (this.verificationResult) break
        }
        this.setVerificationResult(this.verificationResult)
        // do reverse sort
        this.responseList.reverse()
      }
    },
    getLocaleTimeString: function (timestamp) {
      let localeTimeString = null
      if (this.verificationRequesteeSite) {
        let timezoneOffset = this.$tool.getUtcOffset((this.verificationRequesteeSite.timezone))
        let localTimestamp = this.$tool.getLocalTimestamp(+timestamp, timezoneOffset)
        localeTimeString = new Date(localTimestamp).toLocaleString()
        localeTimeString = new Date(localTimestamp).toLocaleTimeString()
      }
      return localeTimeString
    },
    getFriendlyTimeString: function (timestamp) {
      return this.$tool.getTimeDiffFromNow(+timestamp).textDetail
    },
    addTimeCount: function (timeCount) {
      this.countDown += timeCount
      // console.log(this.countDown)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.comp-verification-logs {
  /* common */
  background-color: transparent;
  color: #333;
  /* position */
  /* position: absolute; */
  top: 0;
  left: 0;
  /* size */
  width: 100%;
  height: 100%;
  /* padding: 1em; */
  box-sizing: border-box;
  // overflow: overlay;
  /* min-height: 300px; */
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}


.comp-verification-logs .response-items {
  /* common */
  background-color: hsla(202, 0%, 0%, 1);
  opacity: 1;
  /* size */
  /* max-width: 400px; */
  /* max-height: 400px; */
  width: 100%;
  height: 100%;
  padding: 0 0.8em;
  /* alignment */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  /* animation */
  transition: opacity .3s;
  .response-item-footer {
    margin-top: 1em;
    width: 100%;
    min-height: 0em;
  }
}
.comp-verification-logs .response-items.not-scrollable {
  /* mouse */
  pointer-events: none;
}

.comp-verification-logs .response-items .verification-info {
  /* common */
  background-color: #333;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  /* text */
  text-align: left;
  /* size */
  width: calc(100% - 2px);
  padding: 0.7em;
  box-sizing: border-box;
  /* position */
  margin: 0em 1px 0 1px;
}
.comp-verification-logs .response-items .verification-info .verification-info-item {
  /* common */
  font-size: 12px;
  /* text */
  font-weight: bold;
  /* position */
  margin-bottom: 0.5em;
}
.comp-verification-logs .response-items .verification-info .verification-info-item.highlight {
  /* text */
  text-transform: uppercase;
  font-size: 14px;
}
.comp-verification-logs .response-items .verification-info .verification-info-item:last-child {
  /* position */
  margin-bottom: 0;
}
.comp-verification-logs .response-items .verification-info .verification-info-item .result-badge {
  /* common */
  color: #fff;
  background-color: hsla(202, 0%, 20%, 1);
  border-radius: 2px;
  /* text */
  font-weight: bold;
  text-transform: uppercase;
  /* position */
  display: inline-block;
  margin-right: 0.5em;
  /* size */
  padding: 4px 6px;
}
.comp-verification-logs .response-items .verification-info .verification-info-item .result-badge:last-child {
  /* position */
  margin-right: 0;
}
.comp-verification-logs .response-items .verification-info .verification-info-item .result-badge.blue {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
}
.comp-verification-logs .response-items .verification-info .verification-info-item .result-badge.red {
  /* common */
  background-color: #CD3D64;
}
.comp-verification-logs .response-items .verification-info .verification-info-item .result-badge.black {
  /* common */
  background-color: hsla(202, 0%, 0%, 1);
}
.comp-verification-logs .response-items .verification-info .verification-info-item .result-badge.blink {
  /* animation */
  animation-name: blinking;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

@keyframes blinking {
  0%   {opacity: 0;}
  50%  {opacity: 1;}
  100% {opacity: 0;}
}


.comp-verification-logs .response-items .no-response-text {
  /* common */
  background-color: hsla(0, 0%, 0%, 0.5);
  color: #ddd;
  outline: 1px solid #666;
  font-size: 14px;
  /* text */
  text-align: left;
  /* size */
  width: calc(100% - 2px);
  padding: 0.7em;
  box-sizing: border-box;
  /* position */
  margin: 0.5em 1px 0 1px;
}
.comp-verification-logs .response-items .response-item {
  /* common */
  background-color: #000;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  /* text */
  text-align: left;
  /* style */
  box-shadow: 0 0 1px 0 #fff;
  /* size */
  width: calc(100% - 2px);
  padding: 0.7em;
  box-sizing: border-box;
  /* position */
  margin: 0.5em 1px 0 1px;
}
.comp-verification-logs .response-items .response-item:last-child {
  /* position */
  margin: 0.5em 1px;
}

.comp-verification-logs .response-items .response-item .response-item-title {
  /* size */
  height: 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.comp-verification-logs .response-items .response-item .response-item-title .info-name {
  /* common */
  font-size: 0.8em;
  /* text */
  text-transform: uppercase;
  /* size */
  height: 2em;
}
.comp-verification-logs .response-items .response-item .response-item-title .info-name .slot-number {
  /* common */
  color: #fff;
  background-color: hsla(202, 0%, 20%, 1);
  border-radius: 2px;
  /* text */
  font-weight: bold;
  /* size */
  padding: 0px 6px;
  /* position */
  margin-right: 2px;
}
.comp-verification-logs .response-items .response-item .response-item-title .info-time {
  /* common */
  font-size: 1em;
}
.comp-verification-logs .response-items .response-item .response-item-content {
  /* common */
  font-size: 0.8em;
  color: #fff;
  background-color: hsla(202, 0%, 20%, 1);
  border-radius: 2px;
  /* text */
  font-weight: bold;
  text-transform: uppercase;
  /* position */
  display: inline-block;
  /* size */
  padding: 4px 6px;
}
.comp-verification-logs .response-items .response-item .response-item-content.not-crime {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
}
.comp-verification-logs .response-items .response-item .response-item-content.crime {
  /* common */
  background-color: #CD3D64;
}

@media (orientation: landscape) {
  .comp-verification-logs {
    height: fit-content;
    .response-items {
      height: fit-content;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CompVerificationLogs.vue